import instance from "./request.js"

export function getDesignMenu(params) {
	return instance.get('/admin/' + params.wsid +  '/design/menu', { params,  withCredentials: true });
}

export function getMenu(params) {
	return instance.get(params.wsid +  '/menu', { params,  withCredentials: true });
}